export const schedulersStyles = {
    fieldsContentScheduler: {
        box: {
            gridTemplateColumns: ['1fr', '1fr 1fr'],
            gap: 2,
        },
        fullWidth: {
            gridColumn: '1 / -1',
        },
        timeSlotRow: {
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
        },
    },
    pageCreateScheduler: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        }
    },
    pageUpdateScheduler: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
    },
    filterTableSchedulers: {
        box: {
            backgroundColor: 'white'
        }
    },
    tableSchedulers: {
        box: {
            minHeight: 600,
            height: "100%",
            overflow: 'auto',
            width: "100%"
        },
        paper: {
            padding: 2,
            paddingBottom: 4,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    }
}
